import { CompanyTypeReq } from '~/types/CompanyType';
import { Application } from '~/types/Application';
import axios from './axios';

export const companyType = (data: CompanyTypeReq) => {
  return axios.post<Application>('/stages/companyType', data).then((res) => res.data);
};
